import { Routes, Route } from 'react-router-dom';
import { USER_ROLE } from '@fdh/shared';
import { MainAppShell } from './MainAppShell';
import { RequireRole } from './RequireRole';
import { useAuth } from '../../contexts/AuthContext';
import { SettingsPage } from '../../pages/settings';
import { UsagePage } from '../../pages/settings/UsagePage';
import { SubscriptionPage } from '../../pages/settings/SubscriptionPage';
import { InvitationCodeReferrerPage } from '../../pages/settings/InvitationCodeReferrerPage';

const isPaired = (pairedAt: string | undefined): boolean => Boolean(pairedAt && pairedAt.trim() !== '');

const hasConsented = (consentedAt: string | undefined): boolean =>
  Boolean(consentedAt && consentedAt.trim() !== '');

const SettingsRoutes = () => (
  <Routes>
    <Route index element={<SettingsPage />} />
    <Route path="usage" element={<UsagePage />} />
    <Route path="subscription" element={
      <RequireRole role={USER_ROLE.EMPLOYER}>
        <SubscriptionPage />
      </RequireRole>
    } />
    <Route path="invite-referrer" element={<InvitationCodeReferrerPage />} />
  </Routes>
);

export const SettingsAccessGate = () => {
  const { user } = useAuth();

  if (!user) {
    return <SettingsRoutes />;
  }

  const employerMayUseAppUnpaired =
    user.role === USER_ROLE.EMPLOYER && user.emailVerified && hasConsented(user.consentedAt);
  const canUseMainShell =
    user.emailVerified &&
    hasConsented(user.consentedAt) &&
    (isPaired(user.pairedAt) || employerMayUseAppUnpaired);
  if (!canUseMainShell) {
    return <SettingsRoutes />;
  }

  return (
    <MainAppShell>
      <SettingsRoutes />
    </MainAppShell>
  );
};

